const STORAGE_KEY = "ubp_demo_user";

function wait(ms = 600) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function fakeSignup({ name, email, password }) {
  await wait();

  const existing = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (existing && existing.email === email) {
    throw new Error("An account with this email already exists.");
  }

  const user = {
    id: "demo-user-1",
    name,
    email,
    role: "Owner",
    createdAt: new Date().toISOString(),
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...user, password }));
  return user;
}

export async function fakeLogin({ email, password }) {
  await wait();

  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    throw new Error("No account found. Please sign up first.");
  }

  const saved = JSON.parse(raw);

  if (saved.email !== email || saved.password !== password) {
    throw new Error("Invalid email or password.");
  }

  const { password: _pw, ...user } = saved;
  return user;
}

export async function fakeLogout() {
  await wait(300);
  return true;
}

export function getSavedUser() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const { password: _pw, ...user } = JSON.parse(raw);
  return user;
}
